// src/components/SupportPageLayout.jsx
import React from "react";
import "./supportPageLayout.css"
import { Card, Grid, Typography } from "antd";

const { Title, Paragraph } = Typography;

const SupportPageLayout = ({ title, subtitle, children }) => {

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  
  return (
    <div style={{
      padding: screens.xs ? "0px" :"24px",
      backgroundColor: "#f0f4ff",
      minHeight: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start"
    }}>
      <Card
        style={{
          borderRadius: 16,
          width: "100%",
          maxWidth: 650,
          position: "relative",
          background: "rgba(255, 255, 255, 0.9)",
          boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
        }}       
        styles={{
        body: { padding: "32px" },
        }}
      >
        {/* Gradient Bar */}
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "6px",
          width: "100%",
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          background: "linear-gradient(to right, #6366f1, #a855f7, #3b82f6)",
        }} />

        {/* Title */}
        <Title level={3} style={{ textAlign: "center", marginBottom: 8 }}>
          {title}
        </Title>

        {/* Subtitle */}
        {subtitle && (
          <Paragraph className = "supportSubtitle" style={{ textAlign: "center", marginBottom: 24}}>
            {subtitle}
          </Paragraph>
        )}

        {/* Page Content */}
        {children}
      </Card>
    </div>
  );
};

export default SupportPageLayout;
